import { useState } from 'react'
import { Column } from './types'

type ColumnModalProps = {
  column?: Column
  onClose: () => void
  onSave: (title: string, id?: string) => void
}

export const ColumnModal = ({ column, onClose, onSave }: ColumnModalProps) => {
  const [title, setTitle] = useState(column?.title ?? '')
  const [error, setError] = useState('')

  const handleSubmit = () => {
    if (title.trim() === '') {
      setError('カラム名は必須です。')
      return
    }
    onSave(title.trim(), column?.id)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl">
        <h2 className="mb-4 text-lg font-bold text-gray-800">
          {column ? 'カラム名を編集' : 'カラムを追加'}
        </h2>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          placeholder="カラム名"
          autoFocus
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#01695C]"
        />
        {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="rounded-lg bg-[#01695C] px-4 py-2 text-sm text-white hover:opacity-90"
          >
            {column ? '更新' : '追加'}
          </button>
        </div>
      </div>
    </div>
  )
}
